// src/user.utils.ts
function buildUserName(user) {
	return `${user.firstName} ${user.lastName}`;
}
function nicknameOrName(user) {
	const { nickname, ...name } = user;
	return nickname || buildUserName(name);
}
function nicknameOrFirstName({ nickname, firstName }) {
	return nickname || firstName;
}
function buildUserNameWithNickname(user) {
	const nickname = user.nickname ? ` (${user.nickname}) ` : " ";
	return `${user.firstName}${nickname}${user.lastName}`;
}
function toStandAloneUser(user) {
	const name = buildUserNameWithNickname(user);
	return {
		id: user.id,
		name
	};
}
export { buildUserName, buildUserNameWithNickname, nicknameOrFirstName, nicknameOrName, toStandAloneUser };

//# sourceMappingURL=index.mjs.map